import React, { type PropsWithChildren } from 'react';
import noop from 'lodash/noop';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { AsyncBulkOpsCoreFull } from '@atlassian/jira-bulk-operations-full-core/src/async';
import type { BulkOperationsCoreFullProps } from '@atlassian/jira-bulk-operations-full-core/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIssueTableSelectedIssues } from '@atlassian/jira-native-issue-table/src/controllers/selected-issues';

const LoadBulkOpsCore = ({
	bulkOpsCoreEntryPointReference,
}: Pick<BulkOperationsCoreFullProps, 'bulkOpsCoreEntryPointReference'>) => {
	const selectedIssues = useIssueTableSelectedIssues();

	return (
		<AsyncBulkOpsCoreFull
			bulkOpsCoreEntryPointReference={bulkOpsCoreEntryPointReference}
			selectedIssueIds={selectedIssues.map((issue) => Number(issue))}
			onClearAll={noop}
			onSelectAll={noop}
			onClearAllVisible={noop}
			// TODO: assume true, add permission in https://hello.jira.atlassian.cloud/browse/DEE-6355
			// if false, (likely) we don't want to load this component at all
			hasBulkEditPermission
			selectableIssueIds={[]}
		/>
	);
};

export const BulkOperationsWrapper = ({
	children,
	bulkOpsCoreEntryPointReference,
}: PropsWithChildren & Pick<BulkOperationsCoreFullProps, 'bulkOpsCoreEntryPointReference'>) => {
	if (!fg('bulk_operations_in_nin')) {
		return children;
	}

	return (
		<Flex xcss={wrapperStyles} direction="row">
			<Box xcss={childContainerStyles}>{children}</Box>
			<LoadBulkOpsCore bulkOpsCoreEntryPointReference={bulkOpsCoreEntryPointReference} />
		</Flex>
	);
};

const wrapperStyles = xcss({
	height: '100%',
});

const childContainerStyles = xcss({
	flex: 1,
	overflowY: 'auto',
});
